export default "__VITE_ASSET__DSTmBXjp__"